import { Fragment, useCallback } from 'react';

// redux
import { useDispatch } from 'react-redux';
import { doSendForgotPasswordOTP } from '../../../redux/thunks/authentication';

// routing
import { useHistory } from 'react-router-dom';
import routes from '../../../constants/routes';

// components
import CompanyLogo from '../../../assets/images/logo.png';
import ForgotPasswordForm from './ForgotPasswordForm';
import UILink from '../../../components/Buttons/UILink';

import styles from '../styles.module.scss';
import Footer from '../../../components/Footer';
import Typography from '../../../components/Typography/Typography';
import FlexColumn from '../../../components/FlexBox/FlexColumn';
import FlexRow from '../../../components/FlexBox/FlexRow';

const RecoverPassword = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const displayLeftSection = () => (
    <div className={styles['left_section']}>
      <div className={styles['login_image']}></div>
    </div>
  );

  const handleSubmitOtp = useCallback(
    (values) => {
      dispatch(doSendForgotPasswordOTP(values));
    },
    [dispatch],
  );

  const displayRightSection = () => (

    <FlexColumn justifyContent='flex-start' flexWrap='nowrap' className={styles['right_section']}>
      <FlexRow alignItems='end'>
        <img style={{ width: '8rem' }} src={CompanyLogo} alt="Spintly" />
        <Typography variant={"h2M"}> | Partner</Typography>
      </FlexRow>
      <FlexColumn justifyContent='start' styles={{ height: '70dvh' }}>
        <FlexColumn>
          <Typography variant={"b2M"} color='var(--info-700)'>Please enter your Mobile Number. We will send you code to reset your password.</Typography>
          <ForgotPasswordForm handleSubmitOtp={handleSubmitOtp} />
        </FlexColumn>
        <Footer />
      </FlexColumn>
    </FlexColumn>
  );

  return (
    <FlexColumn styles={{ position: 'relative', overflow: 'hidden' }}>
      <FlexColumn flexWrap='nowrap' styles={{ height: '100dvh', zIndex: '1' }}>
        <FlexRow alignItems='end'>
          <img style={{ width: '8rem' }} src={CompanyLogo} alt="Spintly" />
          <Typography variant={"h2M"}> | Partner</Typography>
        </FlexRow>
        <FlexColumn justifyContent='start' styles={{ width: '30rem', maxWidth: '95%' }}>
          <FlexColumn>
            <Typography variant={"b2M"} color='var(--info-700)'>Please enter your Mobile Number. We will send you code to reset your password.</Typography>
            <ForgotPasswordForm handleSubmitOtp={handleSubmitOtp} />
          </FlexColumn>
          <Footer />
        </FlexColumn>
      </FlexColumn>
      <div className={styles['w-circle']} />

    </FlexColumn>
  );
};

export default RecoverPassword;
